(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/mini-meta-column.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/mini-meta-column.js');

'use strict';

const {
  formatCurrency
} = svs.racing_game.components.play.Util;
const {
  infoTypes,
  gameTypeToSubProductId
} = svs.racing.common.constants;
const {
  ReactIcon,
  icon
} = svs.ui;
const {
  dialog
} = svs.components;
const {
  useState,
  useEffect
} = React;
const {
  detect
} = svs.core;
const {
  MiniMetaColumnHeader
} = svs.racing_game.components.play;
const {
  gameTypeIoDistributionDisplay,
  gametypeHasIoDistribution
} = svs.racing.common.util;
const {
  constants
} = svs.racing.common;
const MiniMetaColumn = _ref => {
  let {
    additionalDistanceMap,
    gait,
    gameType,
    getHeaderByGameType,
    type,
    isExpanded,
    header,
    subHeader,
    itemClass,
    expandMiniMeta,
    rows,
    hasExplanation,
    isResult
  } = _ref;
  const [visible, setVisible] = useState(true);
  const iconColor = 'fc-navy';
  const handleHelpButtonClick = (event, type) => {
    let title = '';
    const texts = [];
    switch (type) {
      case infoTypes.BLINKERS:
        title = 'Utrustning';
        texts.push("".concat(icon.partials.icon({
          icon: 'blinkers-australian',
          size: 300,
          color: 'fc-navy'
        }), " Australiensiska Blinkers"));
        texts.push("".concat(icon.partials.icon({
          icon: 'blinkers',
          size: 300,
          color: 'fc-navy'
        }), " Blinkers"));
        break;
      case infoTypes.LAST_PERFORMANCE:
        title = 'Placering senaste starter';
        texts.push(['(18), (19) osv. = år och årsbrytning', '1 till 9 = Placeringen', '0 = Placering 10 eller högre', 'D = Diskvalificerad', 'F = Fallit', 'A = Avstannad', 'N = Nedflyttad', gait === constants.gaits.GALLOP && 's = Steeple chase / Cross Country', gait === constants.gaits.GALLOP && 'h = Hinder-lopp', gait === constants.gaits.TROTTING && 'm = Monté-lopp'].filter(Boolean).join('<br />'));
        texts.push('<em>Avsaknad av data kan bero på starter utanför Franrike eller att hästen är debutant.</em>');
        break;
      case infoTypes.SHOES:
        title = 'Hästskor';
        texts.push("".concat(icon.partials.icon({
          icon: 'horseshoe-on',
          size: 300,
          color: 'fc-navy'
        }), " ").concat(icon.partials.icon({
          icon: 'horseshoe-on',
          size: 300,
          color: 'fc-navy'
        }), " Skor runtom"));
        texts.push("".concat(icon.partials.icon({
          icon: 'horseshoe-off',
          size: 300,
          color: 'fc-navy'
        }), " ").concat(icon.partials.icon({
          icon: 'horseshoe-on',
          size: 300,
          color: 'fc-navy'
        }), " Barfota fram"));
        texts.push("".concat(icon.partials.icon({
          icon: 'horseshoe-on',
          size: 300,
          color: 'fc-navy'
        }), " ").concat(icon.partials.icon({
          icon: 'horseshoe-off',
          size: 300,
          color: 'fc-navy'
        }), " Barfota bak"));
        texts.push("".concat(icon.partials.icon({
          icon: 'horseshoe-off',
          size: 300,
          color: 'fc-navy'
        }), " ").concat(icon.partials.icon({
          icon: 'horseshoe-off',
          size: 300,
          color: 'fc-navy'
        }), " Barfota runtom"));
        break;
      default:
        break;
    }
    const contextDialog = new dialog.Contextual({
      branding: dialog.branding.SPORT,
      attachTo: event.currentTarget,
      zIndex: 1100,
      title,
      message: texts.map(text => ({
        text,
        type: dialog.message.TEXT
      }))
    });
    dialog.api.add(contextDialog);
  };
  const convertStringToKebabCase = text => text.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
  const renderShoes = shoes => {
    const size = '400';
    switch (shoes) {
      case 'Both':
        return React.createElement(React.Fragment, null, React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-on",
          size: size
        }), React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-on",
          size: size
        }));
      case 'Front':
        return React.createElement(React.Fragment, null, React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-on",
          size: size
        }), React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-off",
          size: size
        }));
      case 'Rear':
        return React.createElement(React.Fragment, null, React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-off",
          size: size
        }), React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-on",
          size: size
        }));
      default:
        return React.createElement(React.Fragment, null, React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-off",
          size: size
        }), React.createElement(ReactIcon, {
          color: iconColor,
          icon: "horseshoe-off",
          size: size
        }));
    }
  };
  const renderBlinkers = blinkers => {
    const blinkersIconSize = '600';
    switch (blinkers) {
      case 'Yes':
        return React.createElement(ReactIcon, {
          color: iconColor,
          icon: "blinkers",
          size: blinkersIconSize
        });
      case 'Australian':
        return React.createElement(ReactIcon, {
          color: iconColor,
          icon: "blinkers-australian",
          size: blinkersIconSize
        });
      default:
        return '-';
    }
  };
  const renderWeight = (driverTotalWeight, driverWeight) => {
    if (driverTotalWeight) {
      return React.createElement("div", null, driverWeight ? "".concat(driverWeight, " (").concat(driverTotalWeight, ")") : driverTotalWeight);
    }
    return '-';
  };
  const renderEmptyValue = () => React.createElement("div", {
    className: "text margin-center"
  }, "-");
  const RenderDistributionValues = _ref2 => {
    let {
      gameType,
      metaValue
    } = _ref2;
    const gameId = gameTypeToSubProductId[gameType];
    const distribution = metaValue && metaValue.find(distribution => distribution.userProduct.toUpperCase() === gameId);
    return React.createElement("div", {
      className: "in-order-distribution-value-holder"
    }, gametypeHasIoDistribution(gameType) && distribution && distribution.distributionByPos && distribution.distributionByPos.map((dist, index) => React.createElement("div", {
      key: dist.position
    }, index <= gameTypeIoDistributionDisplay(gameType) - 1 && React.createElement("div", {
      className: "in-order-distribution-value"
    }, dist.percent ? "".concat(dist.percent, " %") : '-'))));
  };
  const renderSwitchHandler = meta => {
    switch (type) {
      case infoTypes.PERCENT:
        return meta.value ? React.createElement("div", {
          className: "percent"
        }, detect.formfactor.mobile() ? isExpanded && React.createElement("div", {
          className: "bar"
        }, React.createElement("div", {
          className: "amount",
          style: {
            width: "".concat(meta.value[0].distributionByPos[0].barCoverage, "%")
          }
        })) : React.createElement("div", {
          className: "bar"
        }, React.createElement("div", {
          className: "amount",
          style: {
            width: "".concat(meta.value[0].distributionByPos[0].barCoverage, "%")
          }
        })), React.createElement("div", {
          className: "text"
        }, "".concat(parseFloat(meta.value[0].distributionByPos[0].percent).toFixed(0), "%"))) : renderEmptyValue();
      case infoTypes.ODDS_REF:
        return meta.value ? React.createElement("div", {
          className: "text"
        }, meta.value.toFixed(2)) : renderEmptyValue();
      case infoTypes.ODDS_LATEST:
        return meta.value ? React.createElement("div", {
          className: "odds"
        }, React.createElement("div", null, meta.value.toFixed(2)), meta.trend && React.createElement(ReactIcon, {
          className: "trend-".concat(meta.trend),
          color: iconColor,
          icon: "caret-".concat(meta.trend),
          size: "75"
        })) : renderEmptyValue();
      case infoTypes.SHOW_ODDS:
        return meta.value && meta.value.oddsMin && meta.value.oddsMax ? React.createElement("div", {
          className: "text"
        }, meta.value.oddsMin.toFixed(2), ' ', "-", ' ', meta.value.oddsMax.toFixed(2)) : renderEmptyValue();
      case infoTypes.STRING:
        return React.createElement("div", {
          className: "text"
        }, meta.value);
      case infoTypes.START_GATE:
        return React.createElement("div", {
          className: "text"
        }, meta.value ? meta.value : '-');
      case infoTypes.SHOES:
        return React.createElement("div", {
          className: "text"
        }, renderShoes(meta.value));
      case infoTypes.WEIGHT:
        return React.createElement("div", {
          className: "text"
        }, renderWeight(meta.value, meta.driverWeight));
      case infoTypes.BLINKERS:
        return React.createElement("div", {
          className: "text"
        }, renderBlinkers(meta.value));
      case infoTypes.CURRENCY:
        return React.createElement("div", {
          className: "text"
        }, formatCurrency(meta.value));
      case infoTypes.LAST_PERFORMANCE:
        return React.createElement("div", {
          className: "text"
        }, meta.value ? meta.value : '-');
      case infoTypes.RESULTS:
        return React.createElement("div", {
          className: "text"
        }, React.createElement("span", {
          className: "f-bold"
        }, meta.value.numberRaces, "\xA0 \xA0"), React.createElement("span", null, meta.value.numberVictories, "-", meta.value.numberSecondPlaces, "-", meta.value.numberThirdPlaces));
      case infoTypes.DISTANCE:
        return React.createElement("div", {
          className: "distance"
        }, meta.value ? "".concat(meta.value, " meter") : '-');
      case infoTypes.IO_DISTRIBUTION:
        return React.createElement("div", {
          className: "in-order-distribution"
        }, React.createElement(RenderDistributionValues, {
          gameType: gameType,
          metaValue: meta.value
        }));
      default:
        return React.createElement("div", {
          className: "text"
        }, meta.value);
    }
  };
  const renderSubHeader = () => {
    if (type === infoTypes.ODDS_REF || type === infoTypes.ODDS_LATEST || type === infoTypes.SHOW_ODDS) {
      return React.createElement("div", {
        className: "sub-header"
      }, React.createElement(ReactIcon, {
        color: iconColor,
        icon: "clock-simple mini-meta-header-clock-icon",
        size: "100"
      }), subHeader);
    }
    if (type === infoTypes.IO_DISTRIBUTION) {
      return gametypeHasIoDistribution(gameType) && React.createElement("div", {
        className: "sub-header in-order-distribution-value-holder"
      }, [...Array(gameTypeIoDistributionDisplay(gameType))].map((e, i) =>
      React.createElement("div", {
        key: "".concat(gameType, "_").concat(i)
      }, "".concat(i + 1, ":a"))));
    }
    return React.createElement("span", {
      className: "sub-header mini-meta-extra-header"
    }, subHeader);
  };
  let oldDistance = 0;
  const getDistanceClass = metaRow => {
    const findDistance = additionalDistanceMap.find(item => item.participantId === metaRow.participantId);
    const newDistance = findDistance.additionalDistance;
    if (newDistance !== undefined) {
      if (newDistance > 0 && newDistance !== oldDistance) {
        oldDistance = newDistance;
        return ' meta-additional-distance';
      }
      oldDistance = newDistance;
    }
    return '';
  };


  useEffect(() => {
    if (type === infoTypes.IO_DISTRIBUTION) {
      if (rows[0].value !== false) {
        if (gametypeHasIoDistribution(gameType) && !isResult) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      } else {
        setVisible(false);
      }
    }
  }, [type, rows, gameType, isResult, subHeader]);


  const hasSubHeader = subHeader => {
    if (type === infoTypes.IO_DISTRIBUTION && gameTypeIoDistributionDisplay(gameType) <= 1) {
      subHeader = false;
      return subHeader;
    }
    return subHeader;
  };
  return visible && React.createElement("div", {
    className: "mini-meta-column".concat(type ? ' mini-meta-' : '').concat(type ? convertStringToKebabCase(type) : '')
  }, React.createElement("div", {
    className: "mini-meta-header ".concat(hasSubHeader(subHeader) ? '' : 'middle-align')
  }, React.createElement(MiniMetaColumnHeader, {
    gait: gait,
    gameType: gameType,
    getHeaderByGameType: getHeaderByGameType,
    hasExplanation: hasExplanation,
    header: header,
    onClickHelp: handleHelpButtonClick,
    type: type
  }), hasSubHeader(subHeader) && renderSubHeader()), rows.map(metaRow => {
    let distanceClass = '';
    if (!isResult && metaRow.value) {
      distanceClass = getDistanceClass(metaRow);
    }
    return React.createElement("div", {
      className: "mini-meta-item ".concat(itemClass).concat(distanceClass),
      key: metaRow.participantId,
      onClick: expandMiniMeta
    }, renderSwitchHandler(metaRow));
  }));
};
svs.racing_game.components.play.MiniMetaColumn = MiniMetaColumn;

 })(window);